import { decodeHTML } from 'entities';
import parser, { domToReact } from 'html-react-parser';
import { createElement } from 'react';
// NOTE (2023-04-17): need version 1.0.13 otherwise '<' and anything following in strings gets trimmed
// in version 1.0.14 this is broken, maybe future versions will not be
import xss from 'xss';

// remove scripts and styles, allow links and images
// @ts-ignore
const gentleFilter = new xss.FilterXSS({
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style'],
    whiteList: {
        a: ['alt', 'href', 'target'],
        b: [],
        br: [],
        font: ['size'],
        i: [],
        img: ['width', 'height', 'src', 'srcset', 'title'],
        li: [],
        ol: [],
        p: [],
        strong: [],
        table: [],
        td: [],
        tr: [],
        ul: [],
    },
});

// @ts-ignore
const gentleNoBrFilter = new xss.FilterXSS({
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style'],
    whiteList: {
        a: ['alt', 'href', 'target'],
        b: [],
        font: ['size'],
        i: [],
        img: ['width', 'height', 'src', 'srcset', 'title'],
        li: [],
        ol: [],
        p: [],
        strong: [],
        table: [],
        td: [],
        tr: [],
        ul: [],
    },
});

// remove scripts, styles and images, allow links
// @ts-ignore
const gentleOldFilter = new xss.FilterXSS({
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style', 'img'],
    whiteList: {
        a: ['alt', 'target'],
        b: [],
        br: [],
        font: [],
        i: [],
        li: [],
        ol: [],
        p: [],
        strong: [],
        table: [],
        td: [],
        tr: [],
        ul: [],
    },
});

// @ts-ignore
const bruteFilter = new xss.FilterXSS({
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style'],
    whiteList: {},
});

const fontStyles = ['Inter', 'Jost'];

type SafelyRenderOptions = {
    fontStyle?: number;
    html: string;
    noBr?: boolean;
    old?: boolean;
    wrapper?: string;
};

export const safelyRender = ({
    fontStyle = 2,
    html,
    noBr = false,
    old = false,
    wrapper = 'div',
}: SafelyRenderOptions) => {
    if (!html) {
        return '';
    }
    const filter = noBr ? gentleNoBrFilter : old ? gentleOldFilter : gentleFilter;
    const boldFontName = fontStyles[fontStyle - 1];
    const filteredHtml = filter.process(decodeHTML(html)).trim();
    let safeHtml;
    try {
        const parseOpts = {
            replace: (node: any) => {
                if (node.name === 'b' || node.name === 'strong') {
                    return createElement(
                        'span',
                        { style: { fontFamily: boldFontName, fontWeight: 600 } },
                        domToReact(node.children, parseOpts)
                    );
                }
            },
        };
        safeHtml = wrapper === '' ? filteredHtml : `<${wrapper}>${filteredHtml}</${wrapper}>`;
        safeHtml = parser(safeHtml, parseOpts);
    } catch {
        safeHtml = bruteFilter.process(html).trim();
    }
    return safeHtml;
};

export const sanitizeHtml = (text: string): string => decodeHTML(xss(text));

export const sanitizeHeaderText = (text: string): string => decodeHTML(removeHtml(text)).replace(/\s\s+/g, ' ');

const cleanSpace = (text: string): string => text.replace(/\s/g, ' ');

const removeHtml = (text: string): string => {
    let safeHtml = bruteFilter.process(text);
    safeHtml = cleanSpace(safeHtml);
    return safeHtml;
};

/**
 * remove all html and return a text string - also subs space for <br/> and <li> tags
 */
const removeHtmlWithLineBreaks = (text: string): string => {
    let manuallyCleanedHtml = text || '';
    manuallyCleanedHtml = manuallyCleanedHtml.replace(/<br ?\/?>/g, ' ');
    manuallyCleanedHtml = manuallyCleanedHtml.replace(/<li>/g, ' ').trimStart();
    return removeHtml(manuallyCleanedHtml);
};

/**
 * sanitizes meta data by removing HTML, and replaces whitespace characters with single spaces
 */
export const safelyEscapeText = (text: string): string =>
    sanitizeHtml(removeHtmlWithLineBreaks(text)).replace(/\s\s+/g, ' ');

/**
 * sanitizes meta data by removing HTML
 */
export const safelyEscapeTextSpaceful = (text: string): string => sanitizeHtml(removeHtmlWithLineBreaks(text));
